export default __webpack_public_path__ + "static/statusdesk02-4ccad09e412af0c68d4fcb1257887684.png";